module.exports = __webpack_public_path__ + "img/box4-img1.e5f6afae.png";